module.exports = __webpack_public_path__ + "img/caiyuanwei.167b881a.jpg";